import {IRange} from "@pg-design/inputs";

export function stringifySearchFormArea(area: IRange<string>): string {
    const lowerIsEmpty = !area.lower || area.lower === "";
    const upperIsEmpty = !area.upper || area.upper === "";

    if (lowerIsEmpty && upperIsEmpty) {
        return "";
    }

    return `${area.lower} - ${area.upper}`;
}
import {IRange} from "@pg-design/inputs";

export function stringifySearchFormArea(area: IRange<string>): string {
    const lowerIsEmpty = !area.lower || area.lower === "";
    const upperIsEmpty = !area.upper || area.upper === "";

    if (lowerIsEmpty && upperIsEmpty) {
        return "";
    }

    return `${area.lower} - ${area.upper}`;
}
